import styled from "@emotion/styled";
import { LightMode } from "@repo/skapa";
import { Text } from "@repo/skapa";
import { pixels, useCoWorkerName } from "@repo/ui";

const Avatar = styled.div<{ small?: boolean }>`
  height: ${({ small }) =>
    small ? pixels.avatarHeightSmall : pixels.avatarHeight};
  width: ${({ small }) =>
    small ? pixels.avatarHeightSmall : pixels.avatarHeight};
  background-color: ${LightMode.colourStaticWhite};
  border-radius: 50%;
  display: inline-block;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface UserBadgeProps {
  email: string;
  small?: boolean;
}

export const UserBadge = ({ email, small }: UserBadgeProps) => {
  const { initials } = useCoWorkerName(email, email);

  return (
    <Avatar small={small}>
      <Text xsmall={small} bold>
        {initials}
      </Text>
    </Avatar>
  );
};
